import merge from 'deepmerge';
import SalesBackComponents from './salesback';
import JurisdictionComponents from './Jurisdiction';
import report from './report';
import collection from './collection';
import CleanData from './cleandata';

const decorators = merge.all([ SalesBackComponents, JurisdictionComponents, report, CleanData, collection ]);
export default decorators;
